import React from "react";
import {
  FaBehance,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaSpotify,
  FaTwitter,
} from "react-icons/fa";
import { HiOutlineShoppingBag, HiOutlineCollection } from "react-icons/hi";

const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  facebook: FaFacebook,
  instagram: FaInstagram,
  twitter: FaTwitter,
  linkedin: FaLinkedin,
  opensea: HiOutlineCollection,
  redbubble: HiOutlineShoppingBag,
  spotify: FaSpotify,
  behance: FaBehance,
};

export function LinkIcon({
  label,
  className = "h-5 w-5",
}: {
  label: string;
  className?: string;
}) {
  const Icon = iconMap[label.toLowerCase()];
  if (!Icon) return null;
  return <Icon className={className} aria-hidden />;
}
